export const KINOHELD = 'kinoheld'
export const COMPESO = 'compeso'
export const KINOTICKETS = 'mars'
export const DIESEL = 'dieselV2'
export const CORTEC = 'cortec'